<template>
	<div>
		<div class="row mr-auto">
			<footer>
				<div class="footer-top">
					<span><a href="http://mangahot.jp/site/copyright.php">著作権</a></span>
					<span><a href="http://mangahot.jp/site/policy.php">プライバシーポリシー</a> </span>
					<span><a href="http://mangahot.jp/site/inquiry.php">お問い合わせ</a></span>
				</div>

				<div class="footer-bottom" :style="isMobile() ? 'position:relative':''">
                                    <span :style="isMobile() ? 'margin:20px auto;display:block;width:200px;margin-top:20px;':''">©North Stars Pictures,Inc.&nbsp&nbsp<br v-if="isMobile()">@Coamix Inc.&nbsp&nbsp<p :class="isMobile() ? '':'d-inline'"> ©Imagineer Co., Ltd.</p><img id="mai_image" @click="filter_slide" v-if="isMobile() && $route.path == '/recommend'" style="position: fixed;right: 20px;bottom: 30px;z-index: 9999" src="/koreyomo/static/assets/images/mai_mobile.png" alt="logo"></span>
				</div>
			</footer>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Footer',
                data(){
                    return {

                    }
                },
                computed: {
                    platform: () => platform,
                },
                methods:{
                    filter_slide:function(){
                        $('#slider').show('slide', { direction: 'down' }, 500);
                        setTimeout(function(){
                            $('body').css({'overflow':'hidden','position':'fixed'});
                        },400);
                    }
                }
                
	}
</script>

<style>
	@media screen and (max-width:580px) {
		.footer-top {
			padding-top: 25px;
			padding-bottom: 3px;
		}
                .footer-top span{
                        display: list-item;
                        list-style-type: disc;       
                        list-style-position: inside;
                        text-align: left;
                }
	}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue